import React, { useState, useEffect } from 'react';
import { Row, Col, Select, Button, Table, Tag, DatePicker } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { setDomainsList } from 'actions/domainsList';
import { addPost, cleanPostsData, setPostsData } from 'actions/postsData';
import Post from './post';
import requestAPI from 'helpers/requestAPI';
import MainMenu from 'components/mainMenu';

import './index.scss';
import { toastError, toastWarning, toastSuccess } from '../../utils/toastr';

const AutoPoster = ({ addPost, setDomainsList, postData, cleanPostsData, setPostsData }) => {
	const [ serverList, setServerList ] = useState([]);
	const [ server, setServer ] = useState(null);
	const [ dataTable, setDataTable ] = useState([]);
	const [ loadingTable, setLoadingTable ] = useState(false);
	const [ dateLogs, setDateLogs ] = useState({
		startDate: '',
		endDate: ''
	});
	const [ pressedButton, setPressedButton ] = useState('');
	const [ deleteData, setDeleteData ] = useState([]);
	const [ isEditTemplate, setIsEditTemplate ] = useState(false);
	const [ isSpinning, setIsSpinning ] = useState(false);

	const toggleLoadingTable = React.useCallback(() => setLoadingTable(value => !value), []);

	useEffect(() => {
		const params = {
			routeParams: {
				route: 'servers'
			}
		};

		requestAPI(params)
			.then((resp) => {
				const data = resp.data.data.map((elem, i) => {
					return {
						key: i,
						name: elem.name,
						id: elem.id
					};
				});

				return data;
			})
			.then((data) => {
				setServerList(data);
			})
			.catch(() => {
				toastError('Server not respond');
			});
	}, []);

	const { Option } = Select;
	const { RangePicker } = DatePicker;

	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			width: '15%'
		},
		{
			title: 'Links',
			dataIndex: 'link',
			key: 'link',
			render: (value) => {
				if (value !== '') {
					return (
						<a href={`http://${value}`} target="_blank" rel="noopener noreferrer">
							{value}
						</a>
					);
				}
			}
		},
		{
			title: 'List links',
			dataIndex: 'list',
			key: 'list',
			render: (value) => {
				if (value !== '') {
					return (
						<a href={`http://${value}`} target="_blank" rel="noopener noreferrer">
							List
						</a>
					);
				}
			}
		},
		{
			title: 'Date of creation',
			dataIndex: 'date',
			key: 'date'
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			width: '100px',
			render: (value) => {
				if (value !== '') {
					return value ? <Tag color="green">{`${value}`}</Tag> : <Tag color="red">{`${value}`}</Tag>;
				}
			}
		}
	];

	const handleClickStart = () => {
		const isEmptyFields = postData.some(element => {
			if (element.domain === '' || element.textArea.includes('') || element.post_date === '') {
				return true
			} else {
				return false
			}
		})

		if (isEmptyFields) {
			toastWarning('Please fill in all fields!');
			return;
		}

		const data = postData.map((element) => {
			return {
				site_id: element.domain,
				site_url: element.domain_name,
				post_data: element.textArea,
				post_date: element.post_date
			}
		});

		if(isEditTemplate) {
			const params = {
				routeParams: {
					route: 'delay_template',
					id: postData[0].record_id
				},
				method: 'PUT',
				data: {
					site_id: +data[0].site_id,
					site_url: data[0].site_url,
					data: data[0].post_data,
					posted: data[0].post_date,
				}
			}

			requestAPI(params).then((resp) => {
				toastSuccess('Edited.');
				cleanPostsData();
				setIsEditTemplate(false);
			}).catch((err) => {
				toastError(err);
			})

			return;
		}

		toggleLoadingTable();

		const paramsText = {
			routeParams: {
				route: 'template'
			},
			method: 'POST',
			data: {
				data
			}
		};

		requestAPI(paramsText)
			.then((resp) => {
				const success = [];

				resp.data.success_appended_ids.forEach((elem) => {
					elem[2].forEach((urls) => {
						success.push({
							key: urls.id,
							name: elem[1],
							link: urls.url,
							list: elem[3],
							date: moment().format('YYYY-MM-DD'),
							status: true
						});
					});
				});

				const faild = resp.data.not_appended_ids.map((elem, i) => {
					return {
						key: `false-${i}`,
						name: elem[1],
						link: '',
						list: '',
						date: '',
						status: false
					};
				});

				const delay = resp.data.delay_tasks.map((elem) => {
					return {
						key: elem.id,
						name: elem.site_url,
						link: '',
						list: '',
						date: elem.posted,
						status: true,
						isEditable: true
					}
				})
				const results = [ ...success, ...faild, ...delay ];

				return results;
			})
			.then((res) => {
				setDataTable(
					res.map((elem) => {
						return {
							key: elem.key,
							name: elem.name,
							link: elem.link,
							list: elem.list,
							date: elem.date,
							status: elem.status
						};
					})
				);
				cleanPostsData();
				toggleLoadingTable();
			})
			.catch((err) => toastError(err));
	};

	const handleSelectServer = async (serverName) => {
		setIsSpinning(true)
		const params = {
			routeParams: {
				route: 'servers',
				id: serverName
			},
			method: 'POST'
		};

		await requestAPI(params).then((resp) => {
			setDomainsList(resp.data.data);
		}).catch(err => {
			toastError(err);
			setDomainsList([]);
		});
		setIsSpinning(false);
	};

	const handleClickAddPost = () => {
		if(isEditTemplate) {
			setIsEditTemplate(false);
			cleanPostsData();
			return;
		}
		if (postData.length) {
			if (
				postData[postData.length - 1].textArea[postData[postData.length - 1].textArea.length - 1] === '' ||
				postData[postData.length - 1].post_date === '' ||
				postData[postData.length - 1].domain === ''
			) {
				toastWarning('Please fill out the post first.');
				return;
			}
		}
		addPost({
			domain: '',
			domain_name: '',
			textArea: [ '' ],
			post_date: moment().format('YYYY-MM-DD')
		});
	};

	const disabledDate = (current) => {
		return current && current > moment().add(1, 'day').endOf('day');
	};

	const handleClickFindLogs = () => {
		toggleLoadingTable();
		const testParams = {
			routeParams: {
				route: 'template'
			},
			additionalQueryStringParams: {
				from_date: dateLogs.startDate,
				to_date: dateLogs.endDate
			}
		};

		requestAPI(testParams)
			.then((resp) => {
				setDataTable(
					resp.data.data.map((elem, i) => {
						return {
							key: elem.id,
							name: elem.site_name,
							link: elem.file_url,
							list: '',
							date: moment(elem.created).format('YYYY-MM-DD'),
							status: ''
						};
					})
				);
			})
			.catch((err) => toastError(err));

			toggleLoadingTable();
			setPressedButton('findPages');
	};

	const handleClickFindDelays = () => {
		toggleLoadingTable();
		const testParams = {
			routeParams: {
				route: 'delay_template'
			}
		};

		requestAPI(testParams)
			.then((resp) => {
				setDataTable(
					resp.data.data.map((elem, i) => {
						return {
							key: elem.id,
							name: elem.site_url,
							link: '',
							list: '',
							date: elem.posted,
							status: '',
							isEditable: true
						};
					})
				);
			})
			.catch((err) => toastError(err));

			toggleLoadingTable();
			setPressedButton('delayPages');
	};

	const rowSelection = {
		onChange: (selectedRowKeys, selectedRows) => {
			setDeleteData(selectedRows);
		},
		getCheckboxProps: (record) => ({
			disabled: record.status === false, // Column configuration not to be checked
			status: record.status
		})
	};

	const handleDeletePage = () => {
		deleteData.forEach((elem, i) => {
			const params = {
				routeParams: {
					route: 'template',
					id: elem.key
				},
				method: 'DELETE'
			};

			requestAPI(params)
				.then(() => {
					if (i === deleteData.length - 1) {
						toastSuccess('All page deleted!');
					}
				})
				.catch(() => toastError(`Site ${elem.link} didn't delete`));
		});

		const removedArr = dataTable.filter(e => {
			return deleteData.find(elem => elem.key !== e.key);
		})

		setDataTable(removedArr);
		setDeleteData(removedArr);
	};

	const handleDeleteDelayPage = () => {
		deleteData.forEach((elem, i) => {
			const params = {
				routeParams: {
					route: 'delay_template',
					id: elem.key
				},
				method: 'DELETE'
			};

			requestAPI(params)
				.then(() => {
					if (i === deleteData.length - 1) {
						toastSuccess('All page deleted!');
					}
				})
				.catch(() => toastError(`Site ${elem.link} didn't delete`));
		});

		const removedArr = dataTable.filter(e => {
			return deleteData.find(elem => elem.key !== e.key);
		})

		setDataTable(removedArr);
		setDeleteData(removedArr);
	}

	const handleSelectOption = (e) => {
		setServer(e);
		handleSelectServer(e);
	}

	const handleChangeDate = React.useCallback((date, dateString) => {
		setDateLogs({ startDate: dateString[0], endDate: dateString[1] })
	}, [])

	const handleDoubleClickRow = (record) => {
		if (!record.isEditable) return; 
		console.log(record)
		const params = {
			routeParams: {
				route: 'delay_template',
				id: record.key
			},
		}

		requestAPI(params).then(record => {
			const data = record.data.data;
			setPostsData({domain: data.site_id, domain_name: data.site_url, textArea: data.data, post_date: data.posted, record_id: data.id}, 0)
			setIsEditTemplate(true);
		})
	}

	return (
		<div className="auto-poster">
			<MainMenu />
			<p className = "auto-poster__title__description">Здесь ты можешь запостить статью на ПБН домене или запланировать отложенный пост</p>
			<Col span={24}>
				<Row className="auto-poster__wrapper">
					<Col span={10}>
						<Row type="flex" align="middle">
							<Col span={8}>Select server:</Col>
							<Col span={12}>
								<Select
									style={{ width: '100%' }}
									value={server}
									onSelect={handleSelectOption}
									className="auto-poster__select"
								>
									{serverList &&
										serverList.map((elem) => {
											return (
												<Option value={elem.id} key={elem.key}>
													{elem.name}
												</Option>
											);
										})}
								</Select>
							</Col>
						</Row>
						<Row>
							{postData.map((post, i) => {
								return <Post isSpinning={isSpinning} key={i} keyValue={i} isEditable={isEditTemplate} />;
							})}
						</Row>
						<Row>
							<Col span={20} className="auto-poster__button-column">
								<Button type="normal" size="large" icon={isEditTemplate ? null : "plus"} onClick={handleClickAddPost}>
									{isEditTemplate ? 'Cancel' : 'Add post'}
								</Button>
								<Button onClick={handleClickStart} type="primary" size="large" className="auto-poster__start-button">
									{isEditTemplate ? 'Edit' : 'Start'}
								</Button>
							</Col>
						</Row>
					</Col>
					<Col span={12}>
						<Col span={24}>
							<Row>Script execution logs:</Row>
							<Table
								rowSelection={rowSelection}
								columns={columns}
								dataSource={dataTable}
								pagination={false}
								size={'small'}
								loading={loadingTable}
								scroll={{ y: '264px', x: '600px' }}
								onRow={(record, rowIndex) => {
									return {
										onDoubleClick: () => {
											handleDoubleClickRow(record);
										}
									}
								}}
							/>
							<br />
							<RangePicker
								disabledDate={disabledDate}
								onChange={handleChangeDate}
							/>
							<br />
							<Row className="auto-poster__find-logs">
								<Button className="auto-poster__find-logs__button" onClick={handleClickFindLogs} type="primary">
									Find added pages
								</Button>
								<Button onClick={handleDeletePage} disabled={!deleteData.length || pressedButton !== 'findPages'} type="danger">
									Delete selected page
								</Button>
							</Row>
							<Row className="auto-poster__find-logs">
								<Button className="auto-poster__find-logs__button" onClick={handleClickFindDelays} type="primary">
									Find delay pages
								</Button>
								<Button onClick={handleDeleteDelayPage} disabled={!deleteData.length || pressedButton !== 'delayPages'} type="danger">
									Delete delay page
								</Button>
							</Row>
						</Col>
					</Col>
				</Row>
			</Col>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		postData: state.postsData
	};
};

const mapDispatchToProps = (dispatch) => ({
	addPost: (data) => dispatch(addPost(data)),
	setDomainsList: (data) => dispatch(setDomainsList(data)),
	cleanPostsData: () => dispatch(cleanPostsData()),
	setPostsData: (data, key) => dispatch(setPostsData(data, key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoPoster);
